import { sb } from '../../supabase.ts';
import { escapeHtml } from '../../main.ts';
import { IMGBB_API_KEY } from '../../config.ts';

export async function renderOtherSchoolEditDetailsPage(app: HTMLElement): Promise<void> {
  const tableName = 'student_database_others';
  const loggedInSchool = localStorage.getItem('adminButton');
  const { data: { session } } = await sb.auth.getSession();
  const isSupabaseUser = !!session && !loggedInSchool;

  if (!isSupabaseUser && !loggedInSchool) {
    window.location.href = '/other_school/login';
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const iid = params.get('iid');

  if (!iid) {
    app.innerHTML = '<div class="container"><h1>Error</h1><p>No IID provided.</p></div>';
    return;
  }
  
  const isViewMode = window.location.pathname === '/other_school/view' || params.get('mode') === 'view';

  const dropdownOptions: Record<string, string[]> = {
    religion: ['ISLAM', 'HINDU', 'BUDDHA', 'CHRISTIAN', 'OTHERS'],
    student_gender: ['MALE', 'FEMALE'],
    student_blood_group: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
    status: ['Active', 'TC', 'Dropout', 'Passed'],
    fulldata_ok: ['OK', 'Pending', 'Incomplete'],
    quote_freedomfighter: ['YES', 'NO'],
    board_name: ['COMILLA', 'DHAKA', 'RAJSHAHI', 'JESSORE', 'CHITTAGONG', 'BARISAL', 'SYLHET', 'DINAJPUR', 'MADRASAH'],
    group: ['GENERAL', 'SCIENCE', 'HUMANITIES', 'BUSINESS STUDIES'],
    active_class: ['6', '7', '8', '9', '10'],
    class_2024: ['6', '7', '8', '9', '10'],
    class_2025: ['6', '7', '8', '9', '10'],
    class_2026: ['6', '7', '8', '9', '10'],
    active_section: [],
    section_2024: [],
    section_2025: [],
    section_2026: [],
  };

  const fieldGroups = [
    { name: 'Basic Information', fields: ['session', 'student_name_en', 'student_name_bn', 'birth_registration', 'student_dateofbirth', 'religion', 'student_gender', 'student_blood_group'] },
    { name: 'Active Status', fields: ['active_class', 'active_section', 'active_roll'] },
    { name: 'Class Information 2026', fields: ['class_2026', 'roll_2026', 'section_2026'] },
    { name: 'Class Information 2025', fields: ['class_2025', 'roll_2025', 'section_2025'] },
    { name: 'Father Information', fields: ['father_name_en', 'father_name_bn', 'father_nid', 'father_mobile', 'father_occupation', 'father_dob', 'father_blood_group'] },
    { name: 'Mother Information', fields: ['mother_name_en', 'mother_name_bn', 'mother_nid', 'mother_mobile', 'mother_occupation', 'mother_dob', 'mother_blood_group'] },
    { name: 'Guardian Information', fields: ['guardian_name_en', 'guardian_name_bn', 'guardian_nid', 'guardian_mobile', 'guardian_occupation'] },
    { name: 'Board Information', fields: ['board_name', 'board_roll', 'board_registration', 'group', 'optional_subject'] },
    { name: 'Address Information', fields: ['district_bn', 'district_en', 'upazilla_bn', 'upazilla_en', 'union_bn', 'union_en', 'village_bn', 'village_en', 'postoffice_bn', 'postoffice_en'] },
    { name: 'Attendance', fields: ['rfid_card_no'] },
    { name: 'Additional/Previous Information', fields: ['previous_school', 'admission_date', 'previous_class_roll', 'school_reg_sl', 'comment_school', 'quote_freedomfighter'] },
    { name: 'TC Information', fields: ['status', 'tc_date', 'tc_no'] },
    { name: 'Student URL', fields: ['student_photo_url', 'registration_card_url', 'birth_certificate_url'] },
    { name: 'System Status', fields: ['fulldata_ok'] }
  ];

  const groupColors = [
    { border: '#0ea5e9', bg: 'linear-gradient(135deg, rgba(14,165,233,0.08), rgba(14,165,233,0.01))', icon: '👤' },
    { border: '#6366f1', bg: 'linear-gradient(135deg, rgba(99,102,241,0.08), rgba(99,102,241,0.01))', icon: '⚡' },
    { border: '#ec4899', bg: 'linear-gradient(135deg, rgba(236,72,153,0.08), rgba(236,72,153,0.01))', icon: '📅' },
    { border: '#a855f7', bg: 'linear-gradient(135deg, rgba(168,85,247,0.08), rgba(168,85,247,0.01))', icon: '📆' },
    { border: '#2563eb', bg: 'linear-gradient(135deg, rgba(37,99,235,0.08), rgba(37,99,235,0.01))', icon: '👨' },
    { border: '#10b981', bg: 'linear-gradient(135deg, rgba(16,185,129,0.08), rgba(16,185,129,0.01))', icon: '👩' },
    { border: '#0d9488', bg: 'linear-gradient(135deg, rgba(13,148,136,0.08), rgba(13,148,136,0.01))', icon: '👥' },
    { border: '#f59e0b', bg: 'linear-gradient(135deg, rgba(245,158,11,0.08), rgba(245,158,11,0.01))', icon: '🎓' },
    { border: '#06b6d4', bg: 'linear-gradient(135deg, rgba(6,182,212,0.08), rgba(6,182,212,0.01))', icon: '📍' },
    { border: '#f97316', bg: 'linear-gradient(135deg, rgba(249,115,22,0.08), rgba(249,115,22,0.01))', icon: '📶' },
    { border: '#64748b', bg: 'linear-gradient(135deg, rgba(100,116,139,0.08), rgba(100,116,139,0.01))', icon: '📂' },
    { border: '#ef4444', bg: 'linear-gradient(135deg, rgba(239,68,68,0.08), rgba(239,68,68,0.01))', icon: '🚫' },
    { border: '#d946ef', bg: 'linear-gradient(135deg, rgba(217,70,239,0.08), rgba(217,70,239,0.01))', icon: '🔗' },
    { border: '#eab308', bg: 'linear-gradient(135deg, rgba(234,179,8,0.08), rgba(234,179,8,0.01))', icon: '🛡️' }
  ];

  app.innerHTML = `
<style>
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap');

  .edit-wrap {
    font-family: 'Outfit', sans-serif;
    background:
      radial-gradient(circle at 0% 0%, rgba(14, 165, 233, 0.15), transparent 35%),
      radial-gradient(circle at 100% 0%, rgba(236, 72, 153, 0.15), transparent 35%),
      radial-gradient(circle at 50% 50%, rgba(168, 85, 247, 0.08), transparent 40%),
      radial-gradient(circle at 10% 80%, rgba(16, 185, 129, 0.1), transparent 35%),
      radial-gradient(circle at 90% 80%, rgba(245, 158, 11, 0.1), transparent 35%),
      linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    min-height: 100vh;
    padding-bottom: 48px;
    position: relative;
    color: #1e293b;
    overflow-x: hidden;
  }
  .edit-wrap::before, .edit-wrap::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    filter: blur(120px);
    z-index: 0;
    pointer-events: none;
    opacity: 0.65;
  }
  .edit-wrap::before {
    top: 10%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: rgba(14, 165, 233, 0.2);
    animation: floatOrb1 25s infinite alternate ease-in-out;
  }
  .edit-wrap::after {
    bottom: 20%;
    right: -10%;
    width: 600px;
    height: 600px;
    background: rgba(236, 72, 153, 0.15);
    animation: floatOrb2 30s infinite alternate ease-in-out;
  }
  @keyframes floatOrb1 {
    0% { transform: translate(0, 0) scale(1); }
    100% { transform: translate(100px, 80px) scale(1.15); }
  }
  @keyframes floatOrb2 {
    0% { transform: translate(0, 0) scale(1.1); }
    100% { transform: translate(-120px, -60px) scale(0.9); }
  }

  .sticky-header, .container {
    position: relative;
    z-index: 10;
  }
  
  .sticky-header {
    position: sticky;
    top: 0;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    z-index: 1000;
    padding: 8px 0;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.02);
  }
  
  .sticky-header .container {
    max-width: 900px !important;
    margin: 0 auto !important;
    width: 100% !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .group-card {
    position: relative;
    background: rgba(255, 255, 255, 0.65);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    margin-bottom: 16px;
    overflow: hidden;
    box-shadow: 0 6px 20px -8px rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.01);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  }
  
  .group-card:hover {
    transform: translateY(-2px) scale(1.002);
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.06), 0 0 0 1px var(--accent-color);
    background: rgba(255, 255, 255, 0.85);
  }

  .group-header {
    padding: 8px 16px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.3);
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  
  .group-header h3 {
    margin: 0;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: -0.2px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background: color-mix(in srgb, var(--accent-color) 12%, transparent);
    color: var(--accent-color);
    font-size: 13px;
    border: 1px solid color-mix(in srgb, var(--accent-color) 25%, transparent);
    box-shadow: 0 2px 6px color-mix(in srgb, var(--accent-color) 8%, transparent);
  }

  .grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 16px;
    padding: 16px;
  }
  
  @media (max-width: 768px) {
    .grid-2 {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 12px;
    }
  }
  
  .grid-2 .field-item:has(textarea) {
    grid-column: span 2;
  }
  
  @media (max-width: 768px) {
    .grid-2 .field-item:has(textarea) {
      grid-column: span 1;
    }
  }

  .field-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .field-item label {
    font-size: 10px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: color 0.3s ease;
  }
  
  .group-card:hover .field-item label {
    color: color-mix(in srgb, var(--accent-color) 80%, #1e293b);
  }

  .view-link {
    background: linear-gradient(135deg, var(--accent-color, #0ea5e9), color-mix(in srgb, var(--accent-color, #0ea5e9) 80%, black));
    color: #fff !important;
    padding: 2px 6px;
    border-radius: 6px;
    font-size: 8.5px !important;
    font-weight: 800;
    text-transform: uppercase;
    text-decoration: none !important;
    transition: all 0.2s;
    cursor: pointer;
    box-shadow: 0 2px 6px color-mix(in srgb, var(--accent-color, #0ea5e9) 20%, transparent);
  }
  
  .view-link:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px color-mix(in srgb, var(--accent-color, #0ea5e9) 40%, transparent);
    filter: brightness(1.05);
  }

  .input-wrap {
    display: flex;
    gap: 6px;
    align-items: center;
    width: 100%;
  }

  .field-input {
    flex: 1;
    padding: 6px 10px;
    border: 1.5px solid rgba(203, 213, 225, 0.7);
    border-radius: 10px;
    font-size: 12.5px;
    font-weight: 500;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    color: #1e293b;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.01), inset 0 1px 2px rgba(0, 0, 0, 0.01);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    min-width: 0;
    height: 32px;
    box-sizing: border-box;
  }
  
  .field-input:hover {
    border-color: color-mix(in srgb, var(--accent-color, #3b82f6) 40%, #cbd5e1);
    background: #fff;
  }
  
  .field-input:focus {
    outline: none;
    border-color: var(--accent-color, #3b82f6);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-color, #3b82f6) 15%, transparent);
    background: #fff;
  }

  .field-input[readonly] {
    background: rgba(241, 245, 249, 0.6);
    color: #64748b;
    border-color: rgba(226, 232, 240, 0.5);
    cursor: not-allowed;
  }

  select.field-input {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23475569'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 14px;
    padding-right: 32px;
  }
  
  .group-card:hover select.field-input {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%233b82f6'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 14px;
  }

  textarea.field-input {
    resize: vertical;
    min-height: 52px;
    height: auto;
    font-family: inherit;
    line-height: 1.4;
  }

  .btn-up {
    padding: 0 12px;
    height: 32px;
    background: linear-gradient(135deg, var(--accent-color, #6366f1), color-mix(in srgb, var(--accent-color, #4f46e5) 85%, black));
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 800;
    color: #fff;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 6px color-mix(in srgb, var(--accent-color, #6366f1) 20%, transparent);
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  
  .btn-up:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px color-mix(in srgb, var(--accent-color, #6366f1) 35%, transparent);
    filter: brightness(1.05);
  }

  .photo-banner {
    position: relative;
    background: linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.7)) padding-box,
                linear-gradient(135deg, rgba(14, 165, 233, 0.3), rgba(236, 72, 153, 0.3), rgba(245, 158, 11, 0.3)) border-box;
    border: 2px solid transparent;
    padding: 16px 20px;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  
  .photo-banner::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(14, 165, 233, 0.08) 0%, rgba(162, 93, 241, 0.06) 50%, transparent 100%);
    z-index: 0;
    pointer-events: none;
    animation: rotateGlow 20s linear infinite;
  }
  
  @keyframes rotateGlow {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .student-photo-container {
    display: inline-block;
    position: relative;
    padding: 3px;
    border-radius: 14px;
    background: linear-gradient(135deg, #0ea5e9, #a855f7, #ec4899);
    box-shadow: 0 8px 20px rgba(168, 85, 247, 0.2);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    flex-shrink: 0;
    cursor: pointer;
  }
  
  .student-photo-container::after {
    content: '📷 Upload';
    position: absolute;
    top: 3px;
    left: 3px;
    right: 3px;
    bottom: 3px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 2;
    letter-spacing: 0.5px;
  }
  
  .student-photo-container:hover::after {
    opacity: 1;
  }
  
  .view-only .student-photo-container:hover::after {
    opacity: 0;
  }
  
  .student-photo-container:hover {
    transform: scale(1.05) rotate(1deg);
    box-shadow: 0 15px 30px rgba(168, 85, 247, 0.35);
    background: linear-gradient(135deg, #ec4899, #f59e0b, #10b981);
  }
  
  .view-only .student-photo-container:hover {
    transform: none;
    box-shadow: 0 8px 20px rgba(168, 85, 247, 0.2);
    background: linear-gradient(135deg, #0ea5e9, #a855f7, #ec4899);
    cursor: default;
  }

  .photo-banner img {
    width: 80px;
    height: 100px;
    object-fit: cover;
    border-radius: 10px;
    border: 2px solid #fff;
    background: #f3f4f6;
    cursor: pointer;
    display: block;
  }

  .photo-banner-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    position: relative;
    z-index: 1;
  }

  .photo-banner h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    background: linear-gradient(135deg, #0f172a 30%, #334155 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
  }

  .iid-tag {
    background: linear-gradient(135deg, rgba(14, 165, 233, 0.1), rgba(168, 85, 247, 0.1));
    color: #0284c7;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 700;
    border: 1px solid rgba(14, 165, 233, 0.15);
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.03);
    display: inline-block;
  }

  .actions-bar {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 10px 16px;
    border-radius: 16px;
    position: sticky;
    bottom: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
    z-index: 100;
  }

  .btn.save-glow {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    border: none;
    font-weight: 700;
    box-shadow: 0 6px 12px rgba(16, 185, 129, 0.2);
    border-radius: 10px;
    padding: 8px 24px !important;
    font-size: 13.5px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
  }
  
  .btn.save-glow:hover {
    transform: translateY(-1.5px);
    box-shadow: 0 10px 20px rgba(16, 185, 129, 0.3);
  }

  .btn.id-glow {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    border: none;
    font-weight: 700;
    box-shadow: 0 6px 12px rgba(245, 158, 11, 0.2);
    border-radius: 10px;
    padding: 8px 16px !important;
    font-size: 13px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
  }
  
  .btn.id-glow:hover {
    transform: translateY(-1.5px);
    box-shadow: 0 10px 20px rgba(245, 158, 11, 0.35);
  }

  .btn.id-applied {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    border: none;
    font-weight: 700;
    box-shadow: 0 6px 12px rgba(16, 185, 129, 0.15);
    border-radius: 10px;
    padding: 8px 16px !important;
    font-size: 13px !important;
    cursor: not-allowed;
    opacity: 0.9;
  }

  .btn.back-glow {
    background: rgba(255, 255, 255, 0.85);
    color: #475569;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
    border-radius: 10px;
    padding: 8px 16px !important;
    font-size: 13px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
  }
  
  .btn.back-glow:hover {
    background: #fff;
    color: #1e293b;
    border-color: #cbd5e1;
    transform: translateY(-1.5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  }

  .pill {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.3px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.3s ease;
  }
  
  .pill::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: .4; transform: scale(1.15); }
  }

  #photo-preview {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    border: 2px solid transparent;
    background-clip: padding-box;
    border-radius: 32px;
    padding: 20px;
    box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.2), 0 30px 60px -30px rgba(0, 0, 0, 0.2);
    z-index: 10001;
    display: none;
    pointer-events: none;
    animation: previewFadeIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  }
  
  @keyframes previewFadeIn {
    from { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
    to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  }

  #photo-preview img {
    max-width: 450px;
    max-height: 550px;
    object-fit: contain;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.05);
  }
</style>

<div class="edit-wrap">
  <div class="sticky-header">
    <div class="container">
      <div style="display:flex; align-items:center; gap: 8px;">
        <button onclick="history.back()" class="btn back-glow" style="padding: 4px 10px !important; font-size: 12px !important; display: flex; align-items: center; gap: 4px; border-radius: 8px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" style="margin-right:2px;"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Back
        </button>
        <h1 style="font-size: 15px; font-weight: 800; margin: 0; background: linear-gradient(135deg, #1e293b, #475569); -webkit-background-clip: text; -webkit-text-fill-color: transparent; letter-spacing: -0.3px;">Student ${isViewMode ? 'Profile Viewer' : 'Editor'}</h1>
      </div>
      <div id="globalStatus" class="pill" style="
        background: rgba(14, 165, 233, 0.1);
        color: #0284c7;
        border: 1px solid rgba(14, 165, 233, 0.15);
      ">Ready</div>
    </div>
  </div>

  <div class="container" style="max-width: 900px; padding-top: 16px; margin: 0 auto; box-sizing: border-box; padding-left: 16px; padding-right: 16px;">
    <div class="photo-banner">
      <div class="student-photo-container">
        <img id="studentPhoto" src="" alt="Photo" class="hover-preview">
      </div>
      <div class="photo-banner-info">
        <h2 id="studentNameHeader">Loading...</h2>
        <span class="iid-tag">IID: ${iid}</span>
      </div>
    </div>

    <div id="groupsContainer"></div>

    <div class="actions-bar">
      <button id="saveBtn" class="btn save-glow">Save Changes</button>
    </div>
  </div>
</div>
<div id="photo-preview"><img src="" alt="preview"/></div>
  `;

  const groupsContainer = document.getElementById('groupsContainer')!;
  const globalStatus = document.getElementById('globalStatus')!;
  const studentPhoto = document.getElementById('studentPhoto') as HTMLImageElement;
  const studentNameHeader = document.getElementById('studentNameHeader')!;
  const saveBtn = document.getElementById('saveBtn') as HTMLButtonElement;
  
  const editWrap = document.querySelector('.edit-wrap') as HTMLElement;
  if (isViewMode) {
    editWrap.classList.add('view-only');
    saveBtn.style.display = 'none';
  }

  let addressData: any[] = [];
  async function loadAddressData() {
    try {
      const res = await fetch('/src/address_info.csv');
      const text = await res.text();
      const rows = text.split('\n').filter(r => r.trim());
      const headers = rows[0].split(',');
      addressData = rows.slice(1).map(row => {
        const cols = row.split(',');
        const obj: any = {};
        headers.forEach((h, i) => obj[h.trim()] = cols[i]?.trim());
        return obj;
      });
    } catch (e) { console.error('Failed to load address data', e); }
  }

  function getFieldHtml(field: string, value: any) {
    const val = (value === null || value === undefined) ? '' : value;
    const isReadOnly = (field.toLowerCase() === 'iid') || isViewMode || (field === 'rfid_card_no');
    const isUrl = field.endsWith('_url');
    const isDate = false;
    const addressFields = ['district_en', 'district_bn', 'upazilla_en', 'upazilla_bn', 'union_en', 'union_bn'];
    
    const disabledAttr = isViewMode ? 'disabled' : '';
    const readonlyAttr = isReadOnly ? 'readonly' : '';

    let inputHtml = '';
    if (dropdownOptions[field]) {
      const options = [...dropdownOptions[field]];
      const upperVal = String(val).toUpperCase();
      if (val && !options.includes(upperVal)) options.push(upperVal);
      inputHtml = `
        <select class="field-input" data-field="${field}" ${disabledAttr}>
          <option value="">--Select--</option>
          ${options.map(opt => `<option value="${opt}" ${opt === upperVal ? 'selected' : ''}>${opt}</option>`).join('')}
        </select>
      `;
    } else if (addressFields.includes(field)) {
      inputHtml = `
        <select class="field-input address-select" data-field="${field}" ${disabledAttr}>
          <option value="${val}">${val || '--Select--'}</option>
        </select>
      `;
    } else if (isDate) {
      let dateVal = val;
      if (val) {
        const s = String(val).trim();
        if (s.includes('T')) {
          dateVal = s.split('T')[0];
        } else {
          const parts = s.split(/[-/]/);
          if (parts.length === 3) {
            if (parts[0].length <= 2 && parts[2].length === 4) {
              dateVal = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
            } else if (parts[0].length === 4 && parts[2].length <= 2) {
              dateVal = `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
            }
          } else {
            const d = new Date(s);
            if (!isNaN(d.getTime())) dateVal = d.toISOString().split('T')[0];
          }
        }
      }
      inputHtml = `<input type="date" class="field-input" data-field="${field}" value="${dateVal}" ${readonlyAttr}>`;
    } else if (field.toLowerCase().includes('address') || field.toLowerCase().includes('comment')) {
      inputHtml = `<textarea class="field-input" data-field="${field}" rows="2" ${readonlyAttr}>${val}</textarea>`;
    } else {
      const extraStyle = (field === 'rfid_card_no' && !isViewMode) ? 'style="cursor:pointer;" title="Click to unlock and edit"' : '';
      inputHtml = `<input type="text" class="field-input" data-field="${field}" value="${escapeHtml(String(val))}" ${readonlyAttr} ${extraStyle}>`;
    }

    return `
      <div class="field-item">
        <label>
          ${field.replace(/_/g, ' ')}
          ${isUrl ? `<span class="view-link hover-preview" data-url="${val}">*view</span>` : ''}
        </label>
        <div class="input-wrap">
          ${isUrl && val && val !== 'null' ? (
            (String(val).toLowerCase().endsWith('.pdf') || String(val).toLowerCase().includes('.pdf'))
            ? `<div class="row-thumb hover-preview" data-url="${val}" style="width:40px; height:40px; border-radius:8px; display:flex; align-items:center; justify-content:center; background:#fee2e2; color:#ef4444; font-size:10px; font-weight:800; border:1px solid #fca5a5; cursor:pointer; box-shadow: 0 4px 10px rgba(239,68,68,0.1); flex-shrink:0;">PDF</div>`
            : `<img src="${val}" class="row-thumb hover-preview" style="width:40px; height:40px; object-fit:cover; border-radius:8px; cursor:pointer; border:1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 10px rgba(0,0,0,0.05); flex-shrink:0;" onerror="this.src='https://via.placeholder.com/150?text=Img'">`
          ) : ''}
          ${inputHtml}
          ${isUrl && !isViewMode ? `<button class="btn-up" data-field="${field}">UP</button><input type="file" class="hidden-file" data-field="${field}" style="display:none;" accept="image/*,application/pdf">` : ''}
        </div>
      </div>
    `;
  }

  async function loadData() {
    await loadAddressData();
    globalStatus.textContent = 'Fetching record...';

    // Fetch unique sections for dropdowns
    const { data: sectionData } = await sb.from(tableName).select('active_section').not('active_section', 'is', null);
    if (sectionData) {
      const sections = [...new Set(sectionData.map(r => r.active_section))].sort();
      ['active_section', 'section_2024', 'section_2025', 'section_2026'].forEach(key => {
        dropdownOptions[key] = sections;
      });
    }

    const { data, error } = await sb.from(tableName).select('*').eq('iid', Number(iid)).single();
    
    if (error || !data) {
      app.innerHTML = `<div class="container"><h1>Error</h1><p>${error?.message || 'Record not found'}</p></div>`;
      return;
    }

    if (!isSupabaseUser) {
      const allowedSchool = loggedInSchool || '';
      if (data.input_user_name !== allowedSchool) {
        app.innerHTML = `<div class="container" style="max-width: 600px; padding: 40px 20px; text-align: center; margin: 50px auto;">
          <h1 style="color: #ef4444; font-size: 24px; font-weight: 800; margin-bottom: 12px;">Access Denied</h1>
          <p style="color: #64748b; font-size: 15px;">You do not have permission to view or edit student records belonging to another school.</p>
          <button onclick="history.back()" class="btn back-glow" style="margin-top: 20px; padding: 8px 16px;">Go Back</button>
        </div>`;
        return;
      }
    }

    const photoUrl = data.student_photo_url && data.student_photo_url.trim() && data.student_photo_url !== 'null' ? data.student_photo_url.trim() : 'https://via.placeholder.com/150?text=No+Photo';
    studentPhoto.src = photoUrl;
    studentPhoto.onerror = () => {
      studentPhoto.src = 'https://via.placeholder.com/150?text=No+Photo';
    };
    studentNameHeader.textContent = data.student_name_en || 'Unnamed Student';

    groupsContainer.innerHTML = fieldGroups.map((group, index) => {
      const colorSet = groupColors[index] || groupColors[0];
      return `
        <div class="group-card" style="--accent-color: ${colorSet.border}; border-left: 5px solid ${colorSet.border};">
          <div class="group-header" style="background: ${colorSet.bg};">
            <div class="icon-wrapper">
              ${colorSet.icon}
            </div>
            <h3 style="color: color-mix(in srgb, var(--accent-color) 90%, #1e293b);">
               ${group.name}
            </h3>
          </div>
          ${group.name === 'Guardian Information' && !isViewMode ? `
            <div style="padding: 12px 16px 0 16px; display: flex; gap: 20px; align-items: center; font-size: 12px; font-weight: 600; color: #475569;">
              <span style="text-transform: uppercase; font-size: 10px; letter-spacing: 0.5px; color: #64748b;">Copy From:</span>
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="radio" name="guardian_copy" id="copyFatherBtn" style="cursor:pointer; margin: 0;"> Father
              </label>
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="radio" name="guardian_copy" id="copyMotherBtn" style="cursor:pointer; margin: 0;"> Mother
              </label>
            </div>
          ` : ''}
          <div class="grid-2">
            ${group.fields.map(f => getFieldHtml(f, data[f])).join('')}
          </div>
        </div>
      `;
    }).join('');

    setupAddressListeners(data);

    // Setup Copy Guardian Info Listener
    const copyFather = document.getElementById('copyFatherBtn') as HTMLInputElement | null;
    const copyMother = document.getElementById('copyMotherBtn') as HTMLInputElement | null;
    if (copyFather && copyMother) {
      const fieldsToCopy = ['name_en', 'name_bn', 'nid', 'mobile', 'occupation'];
      const doCopy = (role: 'father' | 'mother') => {
        fieldsToCopy.forEach(suffix => {
          const srcInput = groupsContainer.querySelector(`[data-field="${role}_${suffix}"]`) as HTMLInputElement | null;
          const dstInput = groupsContainer.querySelector(`[data-field="guardian_${suffix}"]`) as HTMLInputElement | null;
          if (srcInput && dstInput) {
            dstInput.value = srcInput.value;
            dstInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      };
      copyFather.onchange = () => { if (copyFather.checked) doCopy('father'); };
      copyMother.onchange = () => { if (copyMother.checked) doCopy('mother'); };
    }

    // Setup click to unlock for RFID Card No
    const rfidInput = groupsContainer.querySelector('[data-field="rfid_card_no"]') as HTMLInputElement;
    if (rfidInput && !isViewMode) {
      rfidInput.onclick = () => {
        if (rfidInput.readOnly) {
          const pwd = prompt('Enter password to edit RFID Card No:');
          if (pwd === '11223') {
            rfidInput.readOnly = false;
            rfidInput.style.cursor = 'text';
            rfidInput.title = '';
            rfidInput.focus();
          } else if (pwd !== null) {
            alert('Incorrect password!');
          }
        }
      };
    }

    // Setup events for URLs and Uploads
    groupsContainer.querySelectorAll('.view-link').forEach((link: any) => {
      link.onclick = () => { if(link.dataset.url) window.open(link.dataset.url, '_blank'); };
    });

    groupsContainer.querySelectorAll('.btn-up').forEach((btn: any) => {
      btn.onclick = () => {
        const field = btn.dataset.field;
        (groupsContainer.querySelector(`.hidden-file[data-field="${field}"]`) as HTMLInputElement).click();
      };
    });

    groupsContainer.querySelectorAll('.hidden-file').forEach((fileInp: any) => {
      fileInp.onchange = async () => {
        const file = fileInp.files[0];
        if (!file) return;
        const field = fileInp.dataset.field;
        const btn = groupsContainer.querySelector(`.btn-up[data-field="${field}"]`) as HTMLButtonElement;
        const textInp = groupsContainer.querySelector(`.field-input[data-field="${field}"]`) as HTMLInputElement;
        
        btn.textContent = '...';
        btn.disabled = true;
        try {
          const formData = new FormData();
          formData.append('image', file);

          const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
            method: 'POST',
            body: formData
          });

          if (!response.ok) throw new Error('ImgBB upload failed');
          const resData = await response.json();
          if (!resData.success) throw new Error(resData.error?.message || 'Upload failed');
          
          const publicUrl = resData.data.url;
          textInp.value = publicUrl;
          btn.textContent = 'OK';
          
          if (field === 'student_photo_url') {
            studentPhoto.src = publicUrl;
          }

          // Dynamically update or insert the inline thumbnail in the editor field
          const imgThumb = btn.parentElement?.querySelector('.row-thumb') as HTMLElement | null;
          if (imgThumb) {
            if (imgThumb.tagName.toLowerCase() === 'img') {
              (imgThumb as HTMLImageElement).src = publicUrl;
            } else {
              imgThumb.setAttribute('data-url', publicUrl);
            }
            imgThumb.style.display = 'block';
          } else {
            const isPdf = publicUrl.toLowerCase().endsWith('.pdf') || publicUrl.toLowerCase().includes('.pdf');
            const newThumb = document.createElement(isPdf ? 'div' : 'img');
            newThumb.className = 'row-thumb hover-preview';
            if (isPdf) {
              newThumb.setAttribute('data-url', publicUrl);
              newThumb.style.cssText = 'width:40px; height:40px; border-radius:8px; display:flex; align-items:center; justify-content:center; background:#fee2e2; color:#ef4444; font-size:10px; font-weight:800; border:1px solid #fca5a5; cursor:pointer; box-shadow: 0 4px 10px rgba(239,68,68,0.1); flex-shrink:0;';
              newThumb.textContent = 'PDF';
            } else {
              (newThumb as HTMLImageElement).src = publicUrl;
              newThumb.style.cssText = 'width:40px; height:40px; object-fit:cover; border-radius:8px; cursor:pointer; border:1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 10px rgba(0,0,0,0.05); flex-shrink:0;';
              (newThumb as HTMLImageElement).onerror = () => { (newThumb as HTMLImageElement).src = 'https://via.placeholder.com/150?text=Img'; };
            }
            btn.parentElement?.insertBefore(newThumb, btn.parentElement.firstChild);
          }
          setupHoverPreview();
        } catch (err: any) { alert(err.message); btn.textContent = 'ERR'; }
        finally { btn.disabled = false; }
      };
    });

    // Support clicking the header photo banner directly to upload/change photo
    const photoContainer = document.querySelector('.student-photo-container') as HTMLElement;
    if (photoContainer && !isViewMode) {
      photoContainer.onclick = () => {
        const fileInp = groupsContainer.querySelector('.hidden-file[data-field="student_photo_url"]') as HTMLInputElement;
        if (fileInp) {
          fileInp.click();
        } else {
          alert("Please expand 'Student URL' group to upload photo.");
        }
      };
    }

    globalStatus.textContent = 'Ready';
    setupHoverPreview();
  }

  function setupHoverPreview() {
    const previewEl = document.getElementById('photo-preview')!;
    if (!previewEl) return;
    const previewImg = previewEl.querySelector('img')!;
    if (!previewImg) return;
    
    document.querySelectorAll('.hover-preview, #studentPhoto').forEach((el: any) => {
      el.onmouseenter = (e: any) => {
        const src = e.target.src || e.target.dataset.url;
        if (src && src.trim() !== '' && src !== 'null' && !src.includes('placeholder.com')) {
          const isPdf = src.toLowerCase().endsWith('.pdf') || src.toLowerCase().includes('.pdf');
          if (isPdf) {
            previewEl.style.display = 'none';
            return;
          }
          previewImg.src = src;
          previewImg.onerror = () => {
            previewEl.style.display = 'none';
          };
          previewEl.style.display = 'block';
        }
      };
      el.onmouseleave = () => {
        previewEl.style.display = 'none';
      };
    });
  }

  function setupAddressListeners(currentData: any) {
    const distEn = groupsContainer.querySelector('[data-field="district_en"]') as HTMLSelectElement;
    const distBn = groupsContainer.querySelector('[data-field="district_bn"]') as HTMLSelectElement;
    const upzEn = groupsContainer.querySelector('[data-field="upazilla_en"]') as HTMLSelectElement;
    const upzBn = groupsContainer.querySelector('[data-field="upazilla_bn"]') as HTMLSelectElement;
    const uniEn = groupsContainer.querySelector('[data-field="union_en"]') as HTMLSelectElement;
    const uniBn = groupsContainer.querySelector('[data-field="union_bn"]') as HTMLSelectElement;

    if (!distEn) return;

    // Populate Districts
    const districts = [...new Set(addressData.map(d => `${d.district_en}|${d.district_bn}`))];
    const distEnOpts = districts.map(d => d.split('|')[0]);
    const distBnOpts = districts.map(d => d.split('|')[1]);
    
    if (currentData.district_en && !distEnOpts.includes(currentData.district_en)) distEnOpts.push(currentData.district_en);
    if (currentData.district_bn && !distBnOpts.includes(currentData.district_bn)) distBnOpts.push(currentData.district_bn);

    distEn.innerHTML = '<option value="">--Select District--</option>' + 
      distEnOpts.map(d => `<option value="${d}" ${d === currentData.district_en ? 'selected' : ''}>${d}</option>`).join('');
    distBn.innerHTML = '<option value="">--Select District--</option>' + 
      distBnOpts.map(d => `<option value="${d}" ${d === currentData.district_bn ? 'selected' : ''}>${d}</option>`).join('');

    const updateUpazilas = (dEn: string) => {
      const upazilas = [...new Set(addressData.filter(d => d.district_en === dEn).map(d => `${d.upazila_en}|${d.upazila_bn}`))];
      const upzEnOpts = upazilas.map(u => u.split('|')[0]);
      const upzBnOpts = upazilas.map(u => u.split('|')[1]);

      if (currentData.upazilla_en && !upzEnOpts.includes(currentData.upazilla_en)) upzEnOpts.push(currentData.upazilla_en);
      if (currentData.upazilla_bn && !upzBnOpts.includes(currentData.upazilla_bn)) upzBnOpts.push(currentData.upazilla_bn);

      upzEn.innerHTML = '<option value="">--Select Upazila--</option>' + 
        upzEnOpts.map(u => `<option value="${u}" ${u === currentData.upazilla_en ? 'selected' : ''}>${u}</option>`).join('');
      upzBn.innerHTML = '<option value="">--Select Upazila--</option>' + 
        upzBnOpts.map(u => `<option value="${u}" ${u === currentData.upazilla_bn ? 'selected' : ''}>${u}</option>`).join('');
    };

    const updateUnions = (uEn: string) => {
      const unions = [...new Set(addressData.filter(d => d.upazila_en === uEn).map(d => `${d.union_en}|${d.union_bn}`))];
      const uniEnOpts = unions.map(un => un.split('|')[0]);
      const uniBnOpts = unions.map(un => un.split('|')[1]);

      if (currentData.union_en && !uniEnOpts.includes(currentData.union_en)) uniEnOpts.push(currentData.union_en);
      if (currentData.union_bn && !uniBnOpts.includes(currentData.union_bn)) uniBnOpts.push(currentData.union_bn);

      if (!uniEnOpts.includes('POURASHAVA')) uniEnOpts.push('POURASHAVA');
      if (!uniBnOpts.includes('পৌরসভা')) uniBnOpts.push('পৌরসভা');

      uniEn.innerHTML = '<option value="">--Select Union--</option>' + 
        uniEnOpts.map(un => `<option value="${un}" ${un === currentData.union_en ? 'selected' : ''}>${un}</option>`).join('');
      uniBn.innerHTML = '<option value="">--Select Union--</option>' + 
        uniBnOpts.map(un => `<option value="${un}" ${un === currentData.union_bn ? 'selected' : ''}>${un}</option>`).join('');
    };

    distEn.onchange = () => {
      const selected = addressData.find(d => d.district_en === distEn.value);
      if (selected) distBn.value = selected.district_bn;
      updateUpazilas(distEn.value);
      upzEn.onchange?.(new Event('change'));
    };
    distBn.onchange = () => {
      const selected = addressData.find(d => d.district_bn === distBn.value);
      if (selected) distEn.value = selected.district_en;
      updateUpazilas(distEn.value);
      upzEn.onchange?.(new Event('change'));
    };

    upzEn.onchange = () => {
      const selected = addressData.find(d => d.upazila_en === upzEn.value);
      if (selected) upzBn.value = selected.upazila_bn;
      updateUnions(upzEn.value);
      uniEn.onchange?.(new Event('change'));
    };
    upzBn.onchange = () => {
      const selected = addressData.find(d => d.upazila_bn === upzBn.value);
      if (selected) upzEn.value = selected.upazila_en;
      updateUnions(upzEn.value);
      uniEn.onchange?.(new Event('change'));
    };

    uniEn.onchange = () => {
      if (uniEn.value === 'POURASHAVA') { uniBn.value = 'পৌরসভা'; return; }
      const selected = addressData.find(d => d.union_en === uniEn.value);
      if (selected) uniBn.value = selected.union_bn;
    };
    uniBn.onchange = () => {
      if (uniBn.value === 'পৌরসভা') { uniEn.value = 'POURASHAVA'; return; }
      const selected = addressData.find(d => d.union_bn === uniBn.value);
      if (selected) uniEn.value = selected.union_en;
    };

    // Initial trigger
    if (currentData.district_en) updateUpazilas(currentData.district_en);
    if (currentData.upazilla_en) updateUnions(currentData.upazilla_en);
  }

  async function handleSave() {
    const payload: any = {};
    groupsContainer.querySelectorAll('.field-input').forEach((inp: any) => {
      const f = inp.dataset.field;
      if (f.toLowerCase() !== 'iid' && !inp.readOnly) {
        payload[f] = inp.value === '' ? null : inp.value;
      }
    });

    saveBtn.disabled = true;
    saveBtn.textContent = 'Saving...';
    showSavePopup('saving');
    let q = sb.from(tableName).update(payload).eq('iid', Number(iid));
    if (!isSupabaseUser) {
      q = q.eq('input_user_name', loggedInSchool || '');
    }
    const { error } = await q;
    saveBtn.disabled = false;
    saveBtn.textContent = 'Save Changes';

    if (error) {
      showSavePopup('error', error.message);
    } else {
      showSavePopup('success');
      globalStatus.textContent = '✓ Changes Saved!';
      globalStatus.style.background = 'rgba(16, 185, 129, 0.15)';
      globalStatus.style.color = '#10b981';
      globalStatus.style.borderColor = 'rgba(16, 185, 129, 0.3)';
      setTimeout(() => {
        globalStatus.textContent = 'Ready';
        globalStatus.style.background = 'rgba(14, 165, 233, 0.12)';
        globalStatus.style.color = '#0284c7';
        globalStatus.style.borderColor = 'rgba(14, 165, 233, 0.2)';
      }, 2000);
    }
  }

  saveBtn.onclick = handleSave;
  await loadData();
}

function showSavePopup(status: 'saving' | 'success' | 'error', message: string = '') {
  let popup = document.getElementById('beautiful-save-popup');
  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'beautiful-save-popup';
    popup.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(15, 23, 42, 0.4);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    document.body.appendChild(popup);
  }

  let contentHtml = '';
  if (status === 'saving') {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(20px);
        transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        font-family: 'Outfit', sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 40px;
          height: 40px;
          border: 4px solid rgba(14, 165, 233, 0.1);
          border-top: 4px solid #0ea5e9;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        "></div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Saving...</div>
      </div>
    `;
  } else if (status === 'success') {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(0);
        font-family: 'Outfit', sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          border: 2px solid rgba(16, 185, 129, 0.2);
        ">✓</div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Saveing, .. ok done.</div>
      </div>
    `;
  } else {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(0);
        font-family: 'Outfit', sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          border: 2px solid rgba(239, 68, 68, 0.2);
        ">✗</div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Error: ${message}</div>
      </div>
    `;
  }

  if (!document.getElementById('popup-spin-style')) {
    const style = document.createElement('style');
    style.id = 'popup-spin-style';
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  popup.innerHTML = contentHtml;
  popup.style.display = 'flex';
  
  setTimeout(() => {
    popup!.style.opacity = '1';
    const card = document.getElementById('beautiful-save-card');
    if (card) card.style.transform = 'translateY(0)';
  }, 10);

  if (status === 'success' || status === 'error') {
    setTimeout(() => {
      popup!.style.opacity = '0';
      const card = document.getElementById('beautiful-save-card');
      if (card) card.style.transform = 'translateY(20px)';
      setTimeout(() => {
        popup!.style.display = 'none';
      }, 300);
    }, 2000);
  }
}
